/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Content} from 'pdfmake/interfaces';
import moment from 'moment';

export function footerPdfConfiguration(currentPage: number, pageCount: number, footerImage: string): Content {
    const dateNow = moment()
            .format('DD/MM/YYYY HH:mm');
    const timezone = Intl.DateTimeFormat()
            .resolvedOptions().timeZone;
    const date = `Exported from Orcan System at ${dateNow}`;
    return [
        {
            fontSize: 10,
            color: '#8f8f8f',
            columns: [
                {
                    text: [
                        {
                            text: 'Page ' + currentPage + ' of ' + pageCount + '\n'
                        },
                        {
                            text: date + ' (' + timezone + ').' + '\n'
                        }
                    ],
                    alignment: 'left',
                    width: '80%'
                },
                {
                    image: footerImage,
                    absolutePosition: {x: 502, y: 20}
                }
            ],
            margin: [35, 20, 10, 0]
        }
    ];
}

export const toDataURL = (url: string): Promise<unknown> => fetch(url)
        .then((response) => response.blob())
        .then((blob) => new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = (): void => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        }));
